import styled from "styled-components";

export const AdminSignUpFormControl = styled.form`
    width: 21.65em;
    height: 31.7em;
    background: #FFFFFF;
    border-radius: 1.15em;
    align-self: start;
    padding: 2em 3.5em;
    position: relative;
    box-shadow: 0px .625em 3.75em rgba(38, 45, 118, 0.08);
`